import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MatomoService {

  private matomoUrl = environment.matomoUrl;
    private siteId = environment.matomoSiteId;

    constructor() {
        this.initMatomo();
       
    }

    private initMatomo(): void {
        const _paq = (window as any)._paq || [];
        (window as any)._paq = _paq;

        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        _paq.push(['setTrackerUrl', `${this.matomoUrl}matomo.php`]);
        _paq.push(['setSiteId', this.siteId]);

        const g = document.createElement('script');
        const s = document.getElementsByTagName('script')[0];
        g.type = 'text/javascript';
        g.async = true;
        g.defer = true;
        g.src = `${this.matomoUrl}matomo.js`;
        s.parentNode?.insertBefore(g, s);
    }
}
